// extracted by mini-css-extract-plugin
module.exports = {"options":"OptionList--options--1M3si","title":"OptionList--title--3RsAE","detail":"OptionList--detail--3XeXR"};